import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useRouter } from "next/router";
import { useState } from 'react';

export default function Home({ anyActive }) {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

    return (
      <div className={`flex justify-between items-center gap-6 px-6 h-[60px]`}>
        <button
          className="p-2 rounded-md bg-primary justify-center align-middles text-white shadow-md lg:hidden xl:hidden my-2"
          onClick={() => setIsOpen(!isOpen)}
        >
          Categories
        </button>
        <div
          className={`w-full block flex-grow lg:flex lg:items-center lg:w-auto ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <div className="flex flex-col justify-start align-left align-center text-start lg:flex-row xl:flex-row bg-primary fixed z-50 right-0 top-0 lg:relative xl:relative w-[100%] gap-4 lg:bg-transparent xl:bg-transparent px-4 py-4 md:py-2">
            <div className="flex justify-between items-center py-2">
              <div className="font-bold text-lg text-white block md:hidden">Categories</div>
              <button className="border flex h-[40px] w-[40px] md:hidden justify-center items-center border-yellow text-white rounded-md cursor-pointer" onClick={() => {setIsOpen(false)}}>X</button>
            </div>
            <button
              className={`md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ${
                router.asPath == "/" ||
                router.asPath == "/profile" ||
                router.asPath == "/profile/addproduct"
                  ? "text-white"
                  : router.asPath.split("/")[2] == "books"
                  ? "text-white"
                  : "text-white"
              } `}
              onClick={() => {
                router.push("/category/books");
              }}
            >
              Books
            </button>
            <button
              className={`md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ${
                router.asPath == "/" ||
                router.asPath == "/profile" ||
                router.asPath == "/profile/addproduct"
                  ? "text-white"
                  : router.asPath.split("/")[2] == "computer_and_accessories"
                  ? "text-white"
                  : "text-white"
              }`}
              onClick={() => {
                router.push("/category/computer_and_accessories");
              }}
            >
              Computer and accessories
            </button>
            <button
              className={`md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ${
                router.asPath == "/" ||
                router.asPath == "/profile" ||
                router.asPath == "/profile/addproduct"
                  ? "text-white"
                  : router.asPath.split("/")[2] == "clothes_and_accessories"
                  ? "text-white"
                  : "text-white"
              }`}
              onClick={() => {
                router.push("/category/clothes_and_accessories");
              }}
            >
              Cloths and accessories
            </button>
            <button
              className={`md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ${
                router.asPath == "/" ||
                router.asPath == "/profile" ||
                router.asPath == "/profile/addproduct"
                  ? "text-white"
                  : router.asPath.split("/")[2] == "luggage_and_bags"
                  ? "text-white"
                  : "text-white"
              }`}
              onClick={() => {
                router.push("/category/luggage_and_bags");
              }}
            >
              Luggage and bags
            </button>
            <button
              className={`md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ${
                router.asPath == "/" ||
                router.asPath == "/profile" ||
                router.asPath == "/profile/addproduct"
                  ? "text-white"
                  : router.asPath.split("/")[2] == "furnitures"
                  ? "text-white"
                  : "text-white"
              }`}
              onClick={() => {
                router.push("/category/furnitures");
              }}
            >
              Furnitures
            </button>
            <button
              className={`md:block text-start gap-5 p-2 border border-yellow w-full hover:bg-yellow hover:text-primary text-white lg:text-primary xl:text-primary rounded-md lg:border-none xl:border-none md:text-center lg:text-center xl:text-center ${
                router.asPath == "/" ||
                router.asPath == "/profile" ||
                router.asPath == "/profile/addproduct"
                  ? "text-white"
                  : router.asPath.split("/")[2] == "phones_and_accessories"
                  ? "text-white"
                  : "text-white"
              }`}
              onClick={() => {
                router.push("/category/phones_and_accessories");
              }}
            >
              Phones and accessories
            </button>
          </div>
        </div>
      </div>
    );
}